import _tslib from "tslib";
import { dew as _PDFAcroChoiceDew } from "./PDFAcroChoice";
import { dew as _flagsDew } from "./flags";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var tslib_1 = _tslib;

  var PDFAcroChoice_1 = tslib_1.__importDefault(_PDFAcroChoiceDew());

  var flags_1 = _flagsDew();

  var PDFAcroComboBox =
  /** @class */
  function (_super) {
    tslib_1.__extends(PDFAcroComboBox, _super);

    function PDFAcroComboBox() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    PDFAcroComboBox.fromDict = function (dict, ref) {
      return new PDFAcroComboBox(dict, ref);
    };

    PDFAcroComboBox.create = function (context) {
      var dict = context.obj({
        FT: "Ch",
        Ff: flags_1.AcroChoiceFlags.Combo,
        Kids: []
      });
      var ref = context.register(dict);
      return new PDFAcroComboBox(dict, ref);
    };

    return PDFAcroComboBox;
  }(PDFAcroChoice_1.default);

  exports.default = PDFAcroComboBox; //# sourceMappingURL=PDFAcroComboBox.js.map

  return exports;
}